<template>
  <div>
    <div class="md:flex justify-end">
      <!-- <v-icon> mdi-magnify</v-icon> -->
      <!-- <div class="border-gray-400 border-2 rounded-full">
        <input
          class="w-full px-4 rounded-full"
          placeholder="Search"
          type="text"
          v-model="keySearch"
        />
      </div> -->
    </div>
    <CommonDataTable :keySearch="keySearch" class="mt-4" />
  </div>
</template>
<script>
import CommonDataTable from "../../../screens/adminScreen/common/CommonDataTable";
export default {
  data() {
    return {keySearch:''};
  },
  components: { CommonDataTable },
};
</script>